import { History } from "lucide-react";
import { Container, IconContainer, Mensagem } from "./styles";

export default function HistoricoVazio() {
  return (
    <Container>
      <IconContainer>
        <History size={48} />
      </IconContainer>
      <Mensagem>Não há registros de logs para este histórico.</Mensagem>
    </Container>
  );
}
